import { defineComponent as r, computed as a, createBlock as i, openBlock as s, unref as e, withCtx as o, createElementVNode as l, normalizeClass as p, createVNode as f, renderSlot as c } from "vue";
import { RevLink as m } from "@ds/components/Link";
import { RevPortal as u } from "@ds/components/Portal";
import { tw as d } from "../../utils/tailwind.js";
const v = /* @__PURE__ */ r({
  name: "RevSkipToContent",
  inheritAttrs: !1,
  __name: "SkipToContent",
  props: {
    toAnchorId: { default: "#main-content" },
    to: { default: "body" }
  },
  setup(h) {
    const n = a(() => d`bg-static-info-max
  fixed inset-x-0 top-0 w-full -translate-y-full px-16
  py-12 opacity-5 transition
  focus-within:translate-y-0 focus-within:opacity-100
  `);
    return (t, y) => (s(), i(e(u), { to: t.to }, {
      default: o(() => [
        l("div", {
          class: p(n.value)
        }, [
          f(e(m), {
            class: "px-4 py-2",
            to: t.toAnchorId
          }, {
            default: o(() => [
              c(t.$slots, "default")
            ]),
            _: 3
          }, 8, ["to"])
        ], 2)
      ]),
      _: 3
    }, 8, ["to"]));
  }
});
export {
  v as default
};
